import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * Base for ticket notifications: the subject is the ticket.
 */
export default class TicketNotification extends Notification {
  ticket() {
    return this.attrs.notification.subject() || null;
  }
  href() {
    const ticket = this.ticket();
    if (!ticket) return '#';
    const content = this.attrs.notification.content();
    return app.route.discussion(ticket, content?.postNumber);
  }
  excerpt() {
    return this.ticket()?.title() ?? null;
  }

  /**
   * Set for tickets opened without an account and their guest's replies.
   */
  guestName() {
    return this.attrs.notification.content()?.guestName || null;
  }
  trans(key, params) {
    if (params === void 0) {
      params = {};
    }
    return app.translator.trans(`soup-97-support.forum.notifications.${key}`, {
      user: this.attrs.notification.fromUser(),
      id: this.ticket()?.id(),
      ...params
    });
  }
}
flarum.reg.add('soup-97-support', 'forum/components/notifications/TicketNotification', TicketNotification);